import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { BrowserUtils } from '@azure/msal-browser';
import { NgModule } from '@angular/core';
import { I18NEXT_NAMESPACE_RESOLVER } from 'angular-i18next';

import { TicketTypesComponent } from './components/ticket-types/ticket-types.component';
import { RouteNames } from './constants/routes';
import { PostLoginPageComponent } from './components/post-login-page/post-login-page.component';
import { PaymentFailurePageComponent } from '@modules/error-page/components/payment-failure-page/payment-failure-page.component';
import { PaymentSuccessPageComponent } from '@modules/components-common/components/payment-success-page/payment-success-page.component';

const routes: Routes = [
  {
    path: RouteNames.BOOKING_SUMMARY,
    loadChildren: () =>
      import('../modules/booking-summary/booking-summary.module').then(
        (m) => m.BookingSummaryModule
      ),
    resolve: {
      i18next: I18NEXT_NAMESPACE_RESOLVER,
    },
  },
  { path: RouteNames.TICKET_TYPES, component: TicketTypesComponent },
  {
    path: RouteNames.TICKET_SELECTOR,
    loadChildren: () =>
      import('../modules/ticket-search/ticket-search.module').then(
        (m) => m.TicketSelectModule
      ),
    resolve: {
      i18next: I18NEXT_NAMESPACE_RESOLVER,
    },
  },
  {
    path: RouteNames.CUSTOMER_DETAILS,
    loadChildren: () =>
      import('../modules/customer/customer.module').then(
        (m) => m.CustomerModule
      ),

    resolve: {
      i18next: I18NEXT_NAMESPACE_RESOLVER,
    },
  },
  {
    path: RouteNames.FLEXIBLE_TICKETS,
    loadChildren: () =>
      import('../modules/payg-flexi/payg-flexi.module').then(
        (m) => m.FlexiModule
      ),
    resolve: {
      i18next: I18NEXT_NAMESPACE_RESOLVER,
    },
  },
  {
    path: RouteNames.PAYG_TICKETS,
    loadChildren: () =>
      import('../modules/payg-flexi/payg-flexi.module').then(
        (m) => m.PaygModule
      ),
    resolve: {
      i18next: I18NEXT_NAMESPACE_RESOLVER,
    },
  },
  {
    path: RouteNames.SEARCH_RESULT_TICKETS,
    loadChildren: () =>
      import('../modules/ticket-search/ticket-search.module').then(
        (m) => m.TicketSearchModule
      ),
    resolve: {
      i18next: I18NEXT_NAMESPACE_RESOLVER,
    },
  },
  {
    path: RouteNames.BOOKING_CONFIRMATION,
    loadChildren: () =>
      import('../modules/order/order.module').then((m) => m.OrderModule),
    resolve: {
      i18next: I18NEXT_NAMESPACE_RESOLVER,
    },
  },

  {
    path: RouteNames.DIRECT_DEBIT,
    loadChildren: () =>
      import('../modules/direct-debit/direct-debit.module').then(
        (m) => m.DirectDebitModule
      ),
  },

  {
    path: RouteNames.PAGE_NOT_FOUND,
    loadChildren: () =>
      import('../modules/error-page/error-page.module').then(
        (m) => m.ErrorPageModule
      ),
  },
  {
    path: RouteNames.POST_LOGIN,
    component: PostLoginPageComponent,
  },
  {
    path: RouteNames.PAYMENT_FAILED,
    component: PaymentFailurePageComponent,
  },
  {
    path: RouteNames.PAYMENT_SUCCESS,
    component: PaymentSuccessPageComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: RouteNames.TICKET_TYPES,
  },
  {
    path: '**',
    redirectTo: RouteNames.PAGE_NOT_FOUND,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules,
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? 'enabled'
          : 'disabled', // Remove this line to use Angular Universal })
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
